import { DashboardModule } from '@domain-group/suit-theme'

import useOrderItems from '@hooks/useOrderItems'

import OrderItemsTable from './OrderItemsTable'

const OrderItems = (props: { campaignId: number }) => {
  const { campaignId } = props

  const orderItemsPayload = useOrderItems({
    filters: { campaign_id: campaignId },
    requestOptions: {
      include_order_item_campaign_id: true,
      include_order_item_due_date: true,
    },
    performHttpRequests: !!campaignId,
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredOrderItems,
    filteredOrderItemsCount,
    hasFilteredOrderItems,
    loading,
  } = orderItemsPayload

  return (
    <DashboardModule
      boxProps={{ marginBottom: 'large' }}
      contentBoxProps={{ flexDirection: 'column' }}
      loading={loading}
      title="All Order Items"
    >
      {!loading && !hasFilteredOrderItems && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Order Items present.
          </DashboardModule.BlankState.Title>
        </DashboardModule.BlankState>
      )}

      {!loading && hasFilteredOrderItems && (
        <DashboardModule.ScrollableSection>
          <OrderItemsTable orderItems={filteredOrderItems} />
        </DashboardModule.ScrollableSection>
      )}

      <DashboardModule.LoadMoreFooter
        boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
        callbacks={{ loadMore }}
        canLoadMore={canLoadMore}
        entityCount={filteredOrderItemsCount}
        loading={loading}
      />
    </DashboardModule>
  )
}

export default OrderItems
